module.exports = __webpack_public_path__ + "img/p18.e390dbe0.jpg";